import { Pipe, PipeTransform } from '@angular/core';

import type { StyleDefinition } from '@angular/flex-layout';

@Pipe({
  name: 'asNgStyle',
  standalone: true,
})
export class AsNgStylePipe implements PipeTransform {
  transform(classObj: StyleDefinition) {
    return Object.keys(classObj)
      .filter((key) => classObj[key] !== undefined && classObj[key] !== null)
      .map((key) => `${key}:${classObj[key]}`)
      .join(';');
  }
}
